import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-442a73a3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "worp" }
const _hoisted_2 = { class: "left_img" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "pc_title" }, "功能页背景图(PC端)：", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "建议图片小于2M", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "支持GIF、PNG、JPG、JPEG", -1))
const _hoisted_6 = { class: "right_img" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "pc_title" }, "功能页背景图(移动端)：", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "建议图片小于2M", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "图片分辨率1125*2436", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "支持GIF、PNG、JPG、JPEG", -1))

import axios from '@/api/live';
import { computed, ref } from 'vue';
import { message } from 'ant-design-vue';
import { useStore } from 'vuex';
import { useDebounce } from '@/hooks/useDebounce'; //防抖
import CUpload from '@/components/CUpload.vue';
import router from '@/router';
interface FileItem {
  uid: string;
  name?: string;
  status?: string;
  response?: any;
  url?: string;
  type?: string;
  size: number;
  originFileObj: any;
}
interface FileInfo {
  file: FileItem;
  fileList: FileItem[];
}

export default /*#__PURE__*/_defineComponent({
  __name: 'UploadImg',
  emits: ['getclose'],
  setup(__props, { emit }) {

// UploadImg.vue


//图片上传
const loadingpc = ref<boolean>(false);
const loading = ref<boolean>(false);
const form = computed(() => store.state.authorizView.Upload);
const PCimages = ref([]);
const handleChange = (info: FileInfo) => {
  if (info.file?.response?.code === 200) {
    form.value.pcImg = info.file?.response?.data.url;
  }
  if (info.file.status === 'uploading') {
    loadingpc.value = true;
    return;
  } else loadingpc.value = false;
};
const moveImages = ref([]);
// const moveimgurl = form.value.mobileImg;
const handleChangeMove = (info: FileInfo) => {
  if (info.file?.response?.code === 200) {
    form.value.mobileImg = info.file?.response?.data.url;
  }
  if (info.file.status === 'uploading') {
    loading.value = true;
    return;
  } else loading.value = false;
};
const imgDel = (info: any, e: number) => {
  if (e === 0) {
    form.value.pcImg = '';
  } else if (e === 1) {
    form.value.mobileImg = '';
  }
};
const liveBroadcastingRoomId = router.currentRoute.value.params.studioId;
const store = useStore();
const imgSave = useDebounce(async () => {
  await store.dispatch('authorizView/customAuthorization');
  const data = {
    mobile_image_url: form.value.mobileImg,
    pc_image_url: form.value.pcImg,
    studio_id: liveBroadcastingRoomId,
  };
  axios
    .setBgimg(data)
    .then((res) => {
      emit('getclose', false);
      message.success(res.data.message);
    })
    .catch((res) => {
      message.error(res.data.error);
    });
});

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode(CUpload, {
          fileList: PCimages.value,
          "handle-change": handleChange,
          loading: loadingpc.value,
          "image-name": _unref(form).pcImg,
          "click-stop": (info) => imgDel(info, 0),
          class: "ant_upload left"
        }, {
          uploadImg: _withCtx(() => [
            _hoisted_4,
            _hoisted_5
          ]),
          _: 1
        }, 8, ["fileList", "loading", "image-name", "click-stop"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createVNode(CUpload, {
          fileList: moveImages.value,
          "handle-change": handleChangeMove,
          loading: loading.value,
          "image-name": _unref(form).mobileImg,
          "click-stop": (info) => imgDel(info, 1),
          class: "ant_upload right"
        }, {
          uploadImg: _withCtx(() => [
            _hoisted_8,
            _hoisted_9,
            _hoisted_10
          ]),
          _: 1
        }, 8, ["fileList", "loading", "image-name", "click-stop"])
      ])
    ]),
    _createElementVNode("div", null, [
      _createVNode(_component_a_button, {
        type: "primary",
        class: "worp_but",
        onClick: _unref(imgSave)
      }, {
        default: _withCtx(() => [
          _createTextVNode(" 保存")
        ]),
        _: 1
      }, 8, ["onClick"])
    ])
  ], 64))
}
}

})